import ReusableModalWrapper from '../../Modals/Common/ReusableModalWrapper';
import ProductSettlementView from './ProductSettlementView';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const ProductSettlementModal = ({ isOpen, onClose }: Props) => {
  return (
    <ReusableModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title="Detalle de Asentamiento"
      maxWidth="max-w-6xl"
    >
      <ProductSettlementView />
    </ReusableModalWrapper>
  );
};

export default ProductSettlementModal;
